import * as d3 from 'd3'
export default {
  methods: {

    draw_Chart(data, sch) {


      let chtGroup = this.canvasForms
      .append('g')
      .attr('transform', `translate(${sch.x}, ${this.chart.y})`)


      let barChart = chtGroup
      .append('g')
      .attr('transform', `translate(0, 20)`)

      this.gmx_Line(barChart, -10, 280, 0, 0, '#E0E0DF', .5, 1)
      this.gmx_Line(barChart, -10, 280, this.chart.height/2, this.chart.height/2, '#E0E0DF', .5, .5)
      this.gmx_Line(barChart, -10, 280, this.chart.height, this.chart.height, '#E0E0DF', .5, 1)


      let x_ = 0
      data.forEach((d,i)=> {

        this.draw_Delta(barChart, d, x_) // -----> Below

        // Plan (Early - Late)
        let early = this.chart.height - this.axis(d.EP)
        let late = this.chart.height - this.axis(d.LP)

        barChart
        .append('rect')
        .attr('x', x_).attr('y', early)
        .attr('width', this.chart.thick).attr('height', late-early < 0 ? 1 : late-early)
        .attr('fill', '#FEED57').attr('opacity', .75)

        // Actual Bar
        barChart
        .append('rect')
        .attr('x', x_).attr('y', this.chart.height - this.axis(d.ACT)).attr('ry', 12)
        .attr('width', this.chart.thick).attr('height', this.axis(d.ACT))
        .attr('fill', this.gmx_deltaValue(d.LD)).attr('fill-opacity', .3)

        // Actual(%)
        barChart
        .append('text')
        .attr('transform', `translate(${x_ + (this.chart.thick/2)}, ${this.chart.height - this.axis(d.ACT)-1})`)
        .attr('font-size', 11).attr('fill', '#000')
        .attr('text-anchor', 'middle')
        .text(d.ACT.toFixed(1) + '%')

        this.draw_Plan(barChart, d, x_) // -----> Below
        x_+= 60
      })

    },


    draw_Plan(selection, d, x_) {
      selection
      .append('text')
      .attr('transform', `translate(${x_ + (this.chart.thick/2)}, ${-42.5 + 10*0.75})`)
      .attr('font-size', 10).attr('fill', '#757575')
      .attr('text-anchor', 'middle')
      .text(d.EP.toFixed(1) + '%')

      selection
      .append('text')
      .attr('transform', `translate(${x_ + (this.chart.thick/2)}, ${-30.5 + 10*0.75})`)
      .attr('font-size', 10).attr('fill', '#757575')
      .attr('text-anchor', 'middle')
      .text(d.LP.toFixed(1) + '%')
    },


    draw_Delta(selection, d, x_) {
      // Discipline
      selection
      .append('text')
      .attr('transform', `translate(${x_ + (this.chart.thick/2)},${this.chart.height + 10 + 10*0.35})`)
      .attr('font-size', 10).attr('fill', '#333')
      .attr('text-anchor', 'middle')
      .text(d.DISC)

      // Early(%)
      selection
      .append('text')
      .attr('transform', `translate(${x_ + (this.chart.thick/2)}, ${this.chart.height + 30})`)
      .attr('font-size', 10).attr('fill', this.gmx_deltaValue(d.ED))
      .attr('text-anchor', 'middle')
      .text(d.ED.toFixed(1) + '%')

      // Late(%)
      selection
      .append('text')
      .attr('transform', `translate(${x_ + (this.chart.thick/2)}, ${this.chart.height + 34 + 10*0.75})`)
      .attr('font-size', 10).attr('fill', this.gmx_deltaValue(d.LD))
      .attr('text-anchor', 'middle')
      .text(d.LD.toFixed(1) + '%')
    }

  }
}